import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NotificationTooltip = ({ isOpen, onClose, appointmentCount, user }) => {
    const tooltipRef = useRef(null);
    const navigate = useNavigate();

    // Handle click outside notification tooltip
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onClose]);

    const handleClose = (e) => {
        e.stopPropagation(); // Prevent event bubbling to parent elements
        onClose();
        // Mark tooltip as seen for today
        const tooltipShownKey = `notificationTooltipShown_${user.email}_${new Date().toDateString()}`;
        localStorage.setItem(tooltipShownKey, 'true');
    };

    const handleOpenNotificationCenter = (e) => {
        e.stopPropagation(); // Prevent event bubbling to parent elements
        onClose();
        // Mark tooltip as seen for today
        const tooltipShownKey = `notificationTooltipShown_${user.email}_${new Date().toDateString()}`;
        localStorage.setItem(tooltipShownKey, 'true');
        // Navigate to notification center
        navigate('/open-appointments');
    };

    if (!isOpen) return null;

    return (
        <div ref={tooltipRef}
             onClick={(e) => e.stopPropagation()}
             className="absolute top-full right-0 mt-2 w-72 bg-white rounded-lg shadow-lg border border-grey-200 p-4 z-50"
             style={{ minWidth: '280px' }}>
            {/* Arrow pointing to bell */}
            <div className="absolute -top-2 right-4 w-4 h-4 bg-white border-l border-t border-grey-200 transform rotate-45"></div>

            <div className="space-y-3">
                {/* Message */}
                <p className="text-sm text-gray-700">
                    Sie haben <span className="font-bold text-mainBlue">{appointmentCount}</span> {appointmentCount === 1 ? 'Benachrichtigung' : 'Benachrichtigungen'} ausstehend.
                </p>

                {/* Buttons */}
                <div className="flex gap-2 pt-2">
                    <button
                        onClick={handleClose}
                        className="flex-1 px-3 py-2 text-sm bg-cancel hover:bg-cancel text-white rounded transition-colors"
                    >
                        Schließen
                    </button>
                    <button
                        onClick={handleOpenNotificationCenter}
                        className="flex-1 px-3 py-2 text-sm bg-mainBlue hover:bg-blue-600 text-white rounded transition-colors"
                    >
                        Öffnen
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotificationTooltip;
